import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_PROGRESS_REPORTS_REQUEST = 'FETCH_PROGRESS_REPORTS_REQUEST';
export const FETCH_PROGRESS_REPORTS_SUCCESS = 'FETCH_PROGRESS_REPORTS_SUCCESS';
export const FETCH_PROGRESS_REPORTS_FAILURE = 'FETCH_PROGRESS_REPORTS_FAILURE';

export function fetchProgressReport(groupId) {
  return (dispatch) => {
    const url = buildUrl(`/groups/${groupId}/unit-reports`);
    const method = 'GET';

    return dispatch(fetchProgressReportRequest()).payload
      .then((response) => dispatch(fetchProgressReportSuccess(response)))
      .catch((error) => dispatch(fetchProgressReportFailure(error)));

    function fetchProgressReportRequest() {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_REPORTS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchProgressReportSuccess(sessions) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_REPORTS_SUCCESS,
        payload: sessions,
        url,
        method,
        groupId,
      });
    }

    function fetchProgressReportFailure(error) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_REPORTS_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/ProgressReports/actions.js